/*eslint-disable */
import root from '../_helpers/roots';
let userProfileUrl = root.userProfile.link;
let updateUserProfileUrl = root.updateUserProfile.link;
let updaateProfileUrl = root.userAvatar.link;
let updateUserPasswordUrl = root.updatePasswordLink.link;
let proInfoByIndexLinkUrl = root.proInfoByIndexLink.link;
let cvFileUpdateLinkUrl = root.cvFileUpdateLink.link;
let userQuizHistoriesURL = root.userQuizHistoriesUrl.link;
let schoolSuggestionURL = root.schoolSuggestionUrl.link;
import Vue from 'vue'
import router from '../route';
import toast from '../services/toast';
import axios from 'axios';
export default {
  state: {
    profileInfo: {}, // Get Profile Information
    userAvatarState: {}, // Get User Avtar
    deleteAvatar: {}, // Delete User Avatar
    updatePassword: {}, // Update password
    userProInfo:{},  // User Info
    userProInfoByIndex:{}, // User Info By INdex
    getUserAttemptQuizHistoriesState:{}
  },
  mutations: {
    set_profile(state, value) {
      Vue.set(state, 'profileInfo', value);
      //           console.log(value);
    },
    setUserAvatar(state, value) {
      //   state.userAvatarState = value
      Vue.set(state, 'userAvatarState', value);
    },
    deleteUserAvatar(state, value) {
      Vue.set(state, 'deleteAvatar', value)
    },
    setUpdatePassword(state, value) {
      Vue.set(state, 'updatePassword', value)
    },
    userProInfoMuatation(state, value) {
      Vue.set(state, 'userProInfo', value)
    },
    userProInfoByIndexMuatation(state, value) {
      Vue.set(state, 'userProInfoByIndex', value)
    },
    getUserAttemptQuizHistoriesMuatation(state, value) {
      Vue.set(state, 'getUserAttemptQuizHistoriesState', value)
    },
  },
  actions: {
    // Get Profile Information
    getProfile(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(userProfileUrl)
            .then(res => {
              context.commit('set_profile', res.data);
              resolve(res);
            })
        })
        .catch(err => {
          reject(err);
        })
    },

    // Update profile information
    updateProfile(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(updateUserProfileUrl, payload)
          .then((res) => {
            if (res.status == '401' || res.status == '403') {
              router.push('/login')
            } else {

              context.commit('set_profile', res.data);
              toast.success(res.data.msg);
              //router.push('/profile');
            }
          })
          .catch((err) => {

            reject(err);
          })
      })
    },

    // Update user image
    updateAvtar(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(updaateProfileUrl, payload, {
            // headers: {
            //   'Content-Type': null
            // }
          })
          .then((res) => {
            if (res.status != '401' && res.status != '403') {
              if (res.data.code == '1012') {
                context.commit('deleteUserAvatar', res.data);
                toast.success(res.data.msg);
                resolve(res);
              }

            } else {
              router.push('/login')
            }
          })
          .catch((err) => {
            reject(err);
          })

      })
    },

    // Remove user image
    removeAvtar(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(updaateProfileUrl).then(res => {

          toast.success(res.data.msg);
          resolve(res);
        }).catch(err => {

          reject(err);
        })
      })

    },

    // update password
    updatePassword(context, payload) {

      return new Promise((resolve, reject) => {
        axios.put(updateUserPasswordUrl, payload).then(res => {
          if (res.status == 400) {
            toast.error(res.data.msg);
          } else if (res.status == 200) {
            toast.success(res.data.msg);
          }

          resolve(res);
        })
      })

    },

    // update password
    userProInfo(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(updateUserProfileUrl, payload)
        .then(res => {
          context.commit('userProInfoMuatation', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },

    userProInfoByIndex(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(proInfoByIndexLinkUrl + payload.data.id + '/', payload.data.data)
        .then(res => {
          context.commit('userProInfoByIndexMuatation', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    cvFileUpdateFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(cvFileUpdateLinkUrl, payload)
        .then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    cvFileRemoveFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(cvFileUpdateLinkUrl, payload)
        .then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    getUserAttemptQuizHistoriesList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(userQuizHistoriesURL, payload)
        .then(res => {
          context.commit('getUserAttemptQuizHistoriesMuatation', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    getUserAttemptQuizHistoriesList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(userQuizHistoriesURL, payload)
        .then(res => {
          context.commit('getUserAttemptQuizHistoriesMuatation', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    schoolSuggestionFiltersUrl(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(schoolSuggestionURL, payload)
        .then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    }
  },
  getters: {
    getProfileInfo: function(state) {
      return state.profileInfo.data
    },
    getUserPic: state => state.userAvatarState,
    deleteUserPic: state => state.deleteAvatar,
    getUpdatePasswordStatus: state => state.updatePassword,
    userProInfoState: state => state.userProInfo,
    userProInfoByIndexState: state => state.userProInfoByIndex,
    getUserAttemptQuizHistoriesGetters: state => state.getUserAttemptQuizHistoriesState
  }
}